module.exports = __webpack_public_path__ + "media/images/icon_ext_link_white-177d3ecfd7d8f8def80232e7ea34d42c.svg";